import { apiClient } from 'api/apiClient';

const RESOURCE = '/RunReports';

type TReportObject =
	| 'Report'
	| 'DeliveryTicket'
	| 'Invoice'
	| 'ShowroomOrder'
	| 'Proposal'
	| 'ShowroomQuote'
	| 'POSInvoice'
	| 'CreditCardReceipt'
	| 'PurchaseOrder'
	| 'Label'
	| 'WorkOrder'
	| 'FaxPO'
	| 'FaxWO'
	| 'InventoryPO'
	| 'InventoryFax'
	| 'DepositSlips'
	| 'Checks';

type TReportStatus = 'Pending' | 'Complete' | 'Error';

interface IRunReportParameter {
	parameterId: number;
	value?: string | null;
	label?: string | null;
	order?: number;
	typeId?: number;
}

export interface IGetRunReportResponse {
	status: TReportStatus;
	completedFileId: string | null;
	hasTimedOut?: boolean;
}

export interface IPostRunReportsParams {
	instanceId: string;
	userId: number;
	reportId: number;
	reportFormatId: number;
	reportObjectType: TReportObject;
	objectId?: string | null;
	skipIfInProgress?: boolean;
	runReportParameters?: (IRunReportParameter | null)[] | null;
}

export interface IPostRunReportResponse {
	id: string | null;
}

export const postRunReports = async (
	params: IPostRunReportsParams
): Promise<IPostRunReportResponse> => {
	const { data } = await apiClient.post(RESOURCE, params);
	return data;
};

const MAX_RETRIES = 10;
let retries = 0;

export const getRunReports = async (
	reportId: string
): Promise<IGetRunReportResponse[]> => {
	try {
		const { data } = await apiClient.get(
			RESOURCE + `?$filter=id eq ${reportId}`
		);

		retries++;

		if (data[0].status === 'Pending' && retries === MAX_RETRIES) {
			retries = 0;
			return [{ ...data[0], hasTimedOut: true }];
		}

		if (data[0].status === 'Complete' || data[0].status === 'Error') {
			retries = 0;
		}

		return data;
	} catch (error) {
		retries = 0;
		return [{ status: 'Error', completedFileId: null }];
	}
};
